var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.819,
    height: 17.092,
    viewBox: "0 0 12.819 17.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location-pin",
    d: "M9.41,0A6.44,6.44,0,0,0,3,6.456c0,5.059,5.807,10.282,6.054,10.5a.535.535,0,0,0,.711,0c.247-.22,6.054-5.443,6.054-10.5A6.44,6.44,0,0,0,9.41,0Zm0,9.97A3.561,3.561,0,1,1,12.97,6.41,3.565,3.565,0,0,1,9.41,9.97Z",
    transform: "translate(-3)",
    fill: "#5cc13e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.352440e5edeba0ca1fc366189905a7db.svg";
export { ForwardRef as ReactComponent };